import { memo } from "react";
import PropTypes from "prop-types";
import { TRANSPORTATION_TYPES } from "app/constants";
import AirplaneFilledIcon from "app/icons/travel/AirplaneFilledIcon";
import TourFilledIcon from "app/icons/travel/TourFilledIcon";
import TrainFilledIcon from "app/icons/travel/TrainFilledIcon";

const TransportationPicto = ({ transportationTypes, ...props }) => {
	if (
		transportationTypes.length === 1 &&
		transportationTypes[0] === TRANSPORTATION_TYPES.FLIGHT
	) {
		return <AirplaneFilledIcon {...props} />;
	} else if (
		transportationTypes.length === 1 &&
		transportationTypes[0] === TRANSPORTATION_TYPES.TRAIN
	) {
		return <TrainFilledIcon {...props} />;
	} else if (transportationTypes.length > 1) {
		return <TourFilledIcon {...props} />;
	}
	return false;
};

TransportationPicto.propTypes = {
	transportationTypes: PropTypes.array,
};

TransportationPicto.defaultProps = {
	transportationTypes: [],
};

export default memo(TransportationPicto);
